// RcListComponent.js
import React, { Component } from "react";
import axios from "axios";
class RcListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      error: null,
    };
    this.baseURL = "https://fukuyamarccenter.com/item_view_for_json/";
  }
  componentDidMount() {
    this.fetchData();
  }
  fetchData() {
    axios
      .post(
        this.baseURL,
        {
          action: this.props.action,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => {
        this.setState({ data: response.data });
      })
      .catch((error) => {
        this.setState({ error: error });
      });
  }
  render() {
    const { data } = this.state;
    if (!data) {
      return <adide>Loading...</adide>
    }
    return (
        <>
          <adide dangerouslySetInnerHTML={{__html:data}} ></adide>
        </>
    )
  }
}
export default RcListComponent;
